// extracted by mini-css-extract-plugin
export default {"modalBody":"NmfTimeUp_modalBody__5n1pB","cta":"NmfTimeUp_cta__ZXUjg","large":"NmfTimeUp_large__EsT1E"};